var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M33.9852 31.9065H22.5966C21.4855 31.9065 20.5818 32.8245 20.5818 33.9532C20.5818 35.0841 21.4855 36 22.5966 36H33.9852C35.0963 36 36 35.0841 36 33.9532C36 32.8245 35.0963 31.9065 33.9852 31.9065Z",
    fill: "#00825A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.618 7.8077L25.4098 16.5279C25.6701 16.7364 25.7145 17.1191 25.5114 17.3857L12.7175 34.0564C11.9132 35.0862 10.728 35.6689 9.45817 35.6904L2.47392 35.7764C2.10143 35.7807 1.7755 35.5227 1.69084 35.1529L0.103509 28.2515C-0.171628 26.9831 0.103509 25.6716 0.907756 24.6611L13.7651 7.9109C13.9725 7.64216 14.3556 7.59486 14.618 7.8077Z",
    fill: "#00825A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M30.2412 11.3309L28.1607 13.928C27.9512 14.1925 27.5745 14.2355 27.3141 14.0248C24.785 11.978 18.3087 6.72569 16.5118 5.27018C16.2494 5.05519 16.2134 4.6725 16.4251 4.4059L18.4314 1.91411C20.2516 -0.429327 23.4262 -0.644321 25.9871 1.39813L28.929 3.74157C30.1353 4.68754 30.9396 5.93451 31.2147 7.24598C31.5322 8.68859 31.1936 10.1054 30.2412 11.3309Z",
    fill: "#00825A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.f0958495fd0e3910630f618ed5b56f77.svg";
export { ForwardRef as ReactComponent };